import { Link } from 'react-router-dom';

const FAQS: Array<{ q: string; a: string; id?: string }> = [
  {
    q: 'How does FitMap recommend a size?',
    a: "FitMap compares the measurements published on your known brand's size chart against the target brand's size chart, region by region (chest, waist, hip, shoulder, sleeve, thigh, inseam — whichever apply to the garment type). Each region is weighted differently depending on the garment: a jeans comparison weighs waist and hip more heavily than a T-shirt comparison would, for example. The size with measurements closest to yours, region by region, is recommended.",
  },
  {
    q: 'Is this AI or machine learning?',
    a: "No. It's a transparent, deterministic scoring formula over published measurements — the same calculation every time for the same inputs, with no model, no training data, and nothing hidden. You can see exactly which measurements were compared and by how much they differ on every result.",
  },
  {
    q: 'What does "confidence" mean?',
    a: 'Confidence reflects how much published data was available to compare, not how good the fit will be. High confidence means every relevant measurement was published for both brands. Medium or low confidence means some measurements were missing, so the recommendation leans on fewer data points.',
  },
  {
    q: 'Why is a brand or size missing?',
    a: "We only activate a size chart once it's been independently verified against an official source. If a brand you're looking for isn't selectable yet, its chart is still pending verification — see the Brand Coverage page for the full status of every brand we're tracking.",
  },
  {
    q: "What if I don't know my size in any brand?",
    a: 'Set up your FitMap Passport with your own body measurements — comparisons can run directly from those instead of a known brand and size.',
  },
  {
    id: 'privacy',
    q: 'What data does FitMap store about me, and where?',
    a: "Everything you enter — your FitMap Passport measurements, Fit History, Favourites, and recent/favourite brands — is stored only in this browser's local storage, on this device. There is no account, no login, and nothing is sent to or stored on a server beyond the one-off comparison request itself. Clearing your browser data removes it. We never sell your data.",
  },
];

export function HelpPage() {
  return (
    <div className="max-w-3xl space-y-8">
      <div>
        <h2 className="text-lg font-semibold text-ink">Help</h2>
        <p className="mt-1 text-sm text-muted">How FitMap works, and where to find everything.</p>
      </div>

      <div className="space-y-4">
        {FAQS.map((item) => (
          <div key={item.q} id={item.id} className="rounded-2xl border border-stone-200 bg-white p-4 shadow-card scroll-mt-6">
            <p className="text-sm font-semibold text-ink">{item.q}</p>
            <p className="mt-1.5 text-sm text-ink/80">{item.a}</p>
          </div>
        ))}
      </div>

      <div className="rounded-2xl border border-stone-200 bg-white p-4 shadow-card">
        <p className="text-sm font-semibold text-ink">More ways to compare</p>
        <ul className="mt-2 space-y-2 text-sm">
          <li>
            <Link to="/brand-vs-brand" className="font-medium text-brand underline">
              Compare two specific brands directly
            </Link>{' '}
            <span className="text-muted">— pick a brand you know and a brand you want to buy, without comparing against everything.</span>
          </li>
          <li>
            <Link to="/coverage" className="font-medium text-brand underline">
              See what's verified so far
            </Link>{' '}
            <span className="text-muted">— full brand-by-brand, audience-by-audience verification status.</span>
          </li>
        </ul>
      </div>
    </div>
  );
}
